export const BASE_URL = 'https://mobibus-gateway.fleetaware.pt';

export const BUS = BASE_URL + '/artifacts-manager/bus';
export const VERSION = BASE_URL + '/artifacts-manager/version';
export const SET_BETA_BUS = BASE_URL + '/artifacts-manager/betaBus/';
export const GET_BUS = BASE_URL + '/busLocation/getAll';

export const AUTH_URL = 'https://mobibus-auth.fleetaware.pt';
export const AUTH_REALM = 'master';
export const AUTH_CLIENT_ID = 'mobibus-artifacts-manager';
